import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import css from './HaendlerBox.module.css';

/**
 * FairwayBid – die Dealchance als Ring
 *
 * Eine Zahl allein wird überlesen. Ein Ring, der sich einmal füllt, sagt
 * dasselbe in der Zeit, die ein Blick dauert – und weil er bei jeder Anfrage
 * neu läuft, vergleicht das Auge die Anfragen, ohne zu rechnen.
 *
 * Die Bewegung läuft genau einmal, beim Erscheinen. Ein Ring, der dauernd
 * pulsiert, zieht den Blick immer wieder zu sich; der ist dann nicht mehr
 * Information, sondern Störung.
 *
 * Gebaut aus einem Kreis mit unterbrochener Linie: Der Umfang ist die ganze
 * Strecke, der Versatz schiebt sie aus dem Bild. Von "ganz verschoben" auf
 * "Anteil sichtbar" ist eine einzige Übergangsangabe – keine Bildfolge, kein
 * Zeitgeber, nichts, was auf einem müden Rechner ruckelt.
 *
 * Erste Darstellung bewusst bei null: Server und Browser zeichnen dasselbe,
 * die Bewegung beginnt erst nach dem Einhängen. Wer Bewegung abgestellt hat,
 * bekommt den fertigen Ring ohne Umweg (siehe CSS).
 */

const GROESSE = 92;
const STRICH = 9;
const RADIUS = (GROESSE - STRICH) / 2;
const UMFANG = 2 * Math.PI * RADIUS;

const DealRing = ({ wert, stufe, klein = false }) => {
  const [gefuellt, setGefuellt] = useState(0);

  useEffect(() => {
    // Zwei Bilder warten: Sonst setzt der Browser Start- und Zielwert im
    // selben Durchgang und es gibt nichts zu sehen.
    const id = requestAnimationFrame(() => requestAnimationFrame(() => setGefuellt(wert)));
    return () => cancelAnimationFrame(id);
  }, [wert]);

  const versatz = UMFANG - (UMFANG * gefuellt) / 100;

  return (
    <div className={classNames(css.ring, { [css.ringKlein]: klein }, css[`stufe_${stufe}`])}>
      <svg viewBox={`0 0 ${GROESSE} ${GROESSE}`} className={css.ringSvg} aria-hidden="true">
        <circle
          className={css.ringSpur}
          cx={GROESSE / 2}
          cy={GROESSE / 2}
          r={RADIUS}
          strokeWidth={STRICH}
          fill="none"
        />
        <circle
          className={css.ringWert}
          cx={GROESSE / 2}
          cy={GROESSE / 2}
          r={RADIUS}
          strokeWidth={STRICH}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={UMFANG}
          strokeDashoffset={versatz}
        />
      </svg>
      <span className={css.ringZahl}>
        {wert}
        <span className={css.ringProzent}>%</span>
      </span>
    </div>
  );
};

export default DealRing;
